/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import React from 'react'
import { Column } from '../../layout/components/dom'
import { useGlobal } from '../../utility/CTX'
import { ContactButton } from '../../layout/components/button';
import { Helmet } from 'react-helmet';

function FAQ() {
    const { theme } = useGlobal();



    // pull the chagnes from the firebase database...
    // changes are reflected in the version? Changes are posted with each version?
    // changes are associated with a date
    // 
        
    return <Column style={{alignItems: 'center'}}>
        <Helmet>
            <title>FAQ - Gateway Forge</title>
            <meta name="description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />
            <meta property="og:url" content="https://gatewayforge.com/faq" />
            <meta property="og:title" content="FAQ - Gateway Forge" />
            <meta property="og:description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />

        </Helmet>

        <h1>FAQ</h1>

        <p style={{color: theme.yellow}}>Under development...</p>

        <p>Have a question? Reach out!</p>
        <ContactButton />
    </Column>
};





export default FAQ